module.exports = __webpack_public_path__ + "static/img/09-北京十一晋元中学.d2c5997.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/09-北京十一晋元中学.png
// module id = eu/u
// module chunks = 0